export function getCurrentPosition(options?: PositionOptions): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Seu navegador não suporta geolocalização"));
      return;
    }

    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 60000,
      ...options,
    });
  });
}

export function geolocationErrorMessage(error: GeolocationPositionError): string {
  if (error.code === error.PERMISSION_DENIED) {
    return "Permissão de localização negada. Ative nas configurações do navegador.";
  }
  if (error.code === error.POSITION_UNAVAILABLE) {
    return "Não foi possível obter sua localização. Tente novamente.";
  }
  if (error.code === error.TIMEOUT) {
    return "Tempo esgotado ao obter localização. Tente novamente.";
  }
  return "Não foi possível obter sua localização.";
}
